<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Approval Process
    </div>
    <div class="enterprise-network_container_table">
      <el-table :data="formData" border>
        <el-table-column
          label="Approval Node"
          prop="stepName"
          show-overflow-tooltip
        />
        <el-table-column
          label="Operator"
          prop="auditUserName"
          show-overflow-tooltip
        />
        <el-table-column
          label="Status"
          prop="auditStatusName"
          show-overflow-tooltip
        />
        <el-table-column label="Date of Approval" prop="createTime" show-overflow-tooltip>
          <template v-slot:default="{row}">
            {{ row.createTime ? dayjs(row.createTime).format('YYYY-MM-DD') : '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="Remarks of Approval"
          prop="approvalOpinion"
          class-name="text-wrap"
        >
          <template v-slot:default="{row}">
            {{ row.approvalOpinion || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "enterpriseNetworkApprovalProcessDetail",
  methods: {dayjs},
  props: {
    formData: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
/deep/ .text-wrap .cell {
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/approvalProcessDetail.vue